export const uniteOfMeasure: Map<string, string> = new Map([
    ['Meter', 'm'],
    ['Blister', 'Bli.'],
    ['Kilogramm', 'kg'],
    ['Karton', 'Kart.'],
    ['Paar', 'Paar'],
    ['Stück', 'Stk.'],
    ['Rolle', 'Roll.'],
    ['Satz', 'Satz'],
    ['VE', 'VE'],
    ['Pack', 'Pack']
]);
